import axios from "axios";
import { AlertCircle, CheckCircle, Loader2 } from "lucide-react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";


export default function Step12({ prevStep, formData, setFormData, setUser }) {
  const navigate = useNavigate();
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [matriId, setMatriId] = useState("");
  const [error, setError] = useState("");


  useEffect(() => {
    window.history.pushState(null, "", window.location.href);

    const handleBack = () => {
      window.history.pushState(null, "", window.location.href);
    };

    window.addEventListener("popstate", handleBack);

    return () => {
      window.removeEventListener("popstate", handleBack);
    };
  }, []);

  /* ================= RESTORE FORM DATA AFTER PAYMENT REDIRECT ================= */

  useEffect(() => {
    if (!formData?.mobile) {
      const raw = localStorage.getItem("multiStepRegistration_form_v1");

      if (raw) {
        const parsed = JSON.parse(raw);

        console.log("Restored FormData in Step12:", parsed);

        if (setFormData) {
          setFormData(parsed);
        }
      }
    }
  }, [formData, setFormData]);

  const validateAdminSubmit = () => {
    // if (!formData.fname || !formData.gender || !formData.mobile) {
    if (!formData?.fname || !formData?.gender || !formData?.mobile) {
      return "Basic details missing";
    }

    if (!formData.plan) {
      return "Plan not selected";
    }
    return null;
  };

  useEffect(() => {
    if (!formData?.mobile) {
      const raw = localStorage.getItem("multiStepRegistration_form_v1");
      if (raw) {
        const parsed = JSON.parse(raw);
        console.log("Rehydrated in Step12:", parsed);
      }
    }
  }, []);

  const handleSubmit = async () => {
    const err = validateAdminSubmit();
    if (err) {
      alert(err);
      return;
    }
    try {
      setSubmitting(true);
      setError("");

      const f = formData || {};
      const fd = new FormData();
      const add = (key, val) => {
        if (val === undefined || val === null || val === "") return;
        fd.append(key, val);
      };

      console.log("FINAL FORM DATA", f.fatherPoorvegam, f.motherPoorvegam);
      /* ------------------------------------------------
         STEP 1 — BASIC DETAILS
      ------------------------------------------------ */
      add("matriId", f.matriId);
      add("fname", f.fname);
      add("lname", f.lname);

      add("email", f.email);
      add("password", f.password);
      add("profileBy", f.profileBy);
      add("gender", f.gender);
      add("dobDay", f.dobDay);
      add("dobMonth", f.dobMonth);
      add("dobYear", f.dobYear);
      add("maritalStatus", f.maritalStatus);
      add("religion", f.religion);
      add("caste", f.caste);
      add("subCaste", f.subCaste);
      add("countryCode", f.countryCode);
      add("mobile", f.mobile);
      add("aboutus", f.aboutYourself);

      for (let i = 1; i <= 12; i++) {
        add(`g${i}`, f[`g${i}`] ? f[`g${i}`].join(",") : "");
        add(`a${i}`, f[`a${i}`] ? f[`a${i}`].join(",") : "");
      }

      /* ------------------------------------------------
         STEP 4 — HOROSCOPE DETAILS
      ------------------------------------------------ */
      add("moonSign", f.moonSign);
      add("star", f.star);
      add("gothra", f.gothra);
      add("manglik", f.manglik);
      add("horoscopeMatch", f.horoscopeMatch);
      add("parigarasevai", f.parigarasevai);
      add("sevai", f.sevai);
      add("raghu", f.raghu);
      add("keethu", f.keethu);
      add("lagnam", f.lagnam);
      add("birthHour", f.birthHour);
      add("birthMinute", f.birthMinute);
      // add("birthSecond", f.birthSecond);
      add("ampm", f.ampm);
      add("placeOfBirth", f.placeOfBirth);
      add("kuladeivam", f.kuladeivam);
      add("kootam", f.kootam);
      // add("thesaiirupu", f.thesaiirupu);

      /* NEW */
      add("thesaiPlanet", f.thesaiPlanet);
      add("thesaiYears", f.thesaiYears);
      add("thesaiMonths", f.thesaiMonths);
      add("thesaiDays", f.thesaiDays);

      /* ------------------------------------------------
         STEP 5 — CONTACT DETAILS
      ------------------------------------------------ */
      add("country", f.country);
      add("state", f.state);
      add("district", f.district);
      add("city", f.city);
      add("pincode", f.pincode);
      add("residence", f.residence);
      add("address", f.address);
      add("altPhone", f.altPhone);
      add("whatsapp", f.whatsapp);
      add("convenientTime", f.convenientTime);

      /* ------------------------------------------------
         STEP 6 — EDUCATION & OCCUPATION
      ------------------------------------------------ */
      add("education", f.education);
      add("occupation", f.occupation);
      add("educationDetails", f.educationDetails);
      add("occupationDetails", f.occupationDetails);
      add("annualIncome", f.annualIncome);
      add("incomeType", f.incomeType);
      add("otherIncome", f.otherIncome);
      add("employedIn", f.employedIn);
      add("workingHours", f.workingHours);
      add("company_name", f.company_name);
      add("workingLocation", f.workingLocation);

      /* ------------------------------------------------
         STEP 7 — PHYSICAL DETAILS
      ------------------------------------------------ */
      add("HeightText", f.heightText || f.height);
      add("weight", f.weight);
      add("bloodGroup", f.bloodGroup);
      add("complexion", f.complexion);
      add("bodyType", f.bodyType);
      add("diet", f.diet);
      add("smoke", f.smoke);
      add("drink", f.drink);
      add("specialCases", f.specialCases);

      add(
        "hobbies",
        Array.isArray(f.hobbies) ? f.hobbies.join(",") : f.hobbies,
      );
      add(
        "interests",
        Array.isArray(f.interests) ? f.interests.join(",") : f.interests,
      );

      add("otherHobbies", f.otherHobbies);
      add("otherInterests", f.otherInterests);
      add("achievement", f.achievement);
      add("medicalHistory", f.medicalHistory);
      add("passport", f.passport);

      /* ------------------------------------------------
         STEP 8 — FAMILY DETAILS
      ------------------------------------------------ */
      add("familyValues", f.familyValues);
      add("familyType", f.familyType);
      add("familyStatus", f.familyStatus);
      add("mother_tounge", f.motherTongue);
      add("motherTongue", f.motherTongue);

      add("noOfBrothers", f.noOfBrothers);
      add("noOfBrothersMarried", f.noOfBrothersMarried);
      add("noOfSisters", f.noOfSisters);
      add("noOfSistersMarried", f.noOfSistersMarried);
      add("noOfBrothersUnmarried", f.noOfBrothersUnmarried);
      add("noOfSistersUnmarried", f.noOfSistersUnmarried);

      add("fatherName", f.fatherName);
      add("fatherOccupation", f.fatherOccupation);
      add("motherName", f.motherName);
      add("motherOccupation", f.motherOccupation);
      add("fatherPoorvegam", f.fatherPoorvegam);
      add("motherPoorvegam", f.motherPoorvegam);

      add(
        "familyWealth",
        Array.isArray(f.familyWealth)
          ? f.familyWealth.join(",")
          : f.familyWealth,
      );
      add("familyDescription", f.familyDescription);
      add("familyMedicalHistory", f.familyMedicalHistory);

      /* ------------------------------------------------
         STEP 9 — PHOTO UPLOAD
      ------------------------------------------------ */
      if (f.photo && typeof f.photo === "object") {
        fd.append("photo", f.photo);
      }

      /* ------------------------------------------------
         STEP 10 — PARTNER PREFERENCES
      ------------------------------------------------ */
      add(
        "partner_maritalStatus",
        Array.isArray(f.maritalStatus)
          ? f.maritalStatus.join(",")
          : f.maritalStatus,
      );
      add("partner_ageFrom", f.ageFrom);
      add("partner_ageTo", f.ageTo);
      add("partner_heightFrom", f.heightFrom);
      add("partner_heightTo", f.heightTo);

      add("partner_religion", f.religion);
      add("partner_caste", f.caste);
      add("partner_complexion", f.complexion);
      add("partner_residencyStatus", f.residencyStatus);
      add("partner_countryLivingIn", f.country);
      add("partner_state", f.state);
      add("partner_city", f.city);
      add("partner_education", f.partnerEducation || "Any");
      add("partner_occupation", f.partnerOccupation || "Any");
      add("partner_motherTongue", f.motherTongue);
      add("partnerExpectations", f.partnerExpectations);

      /* ------------------------------------------------
         STEP 11 — PLAN SELECTION (Admin Panel - No Payment Required)
      ------------------------------------------------ */

      // Always save the plan for admin-created users
      // add("plan", f.plan || "basic");
      // add("paymentDone", "1");

      /* ------------------------------------------------
   STEP 11 — SECURE PAYMENT VERIFICATION
------------------------------------------------ */

      /* ================= VERIFY PAYMENT ================= */

      // const verifyRes = await axios.get(
      //   "/api/payment/verify",
      //   { params: { email: f.email } }
      // );
      const verifyRes = await axios.get(
        `${process.env.REACT_APP_API_BASE || ""}/api/payment/verify`,
        {
          params: { email: f.email },
        },
      );

      if (!verifyRes.data.valid) {
        alert("Payment not verified.");
        navigate("/register/step/6");
        return;
      }

      /* Add verified plan */
      add("plan", verifyRes.data.plan);
      add("paymentDone", "1");

      /* ------------------------------------------------
         FILE UPLOAD — HOROSCOPE FILE (correct Multer field)
      ------------------------------------------------ */
      if (f.horoscopeFile && typeof f.horoscopeFile === "object") {
        fd.append("horoscopeFile", f.horoscopeFile);
      }

      console.log("Submitting payload:", Object.fromEntries(fd.entries()));

      /* ------------------------------------------------
         SUBMIT TO BACKEND
      ------------------------------------------------ */
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE || ""}/api/register/complete`,
        fd,
      );

      localStorage.removeItem("multiStepRegistration_form_v1");

      setMatriId(res.data.matriId);
      setSubmitted(true);

      // 🔐 AUTO LOGIN AFTER REGISTER
      const loginRes = await axios.post(
        `${process.env.REACT_APP_API_BASE || ""}/api/auth/login`,
        {
          email: f.email,
          password: f.password,
        },
      );

      if (loginRes.data?.success) {
        localStorage.setItem("loggedInEmail", f.email);
        localStorage.setItem(
          "userData",
          JSON.stringify(loginRes.data.user || {}),
        );

        if (setUser) {
          setUser(loginRes.data.user);
        }

        navigate("/profile");
      } else {
        throw new Error("Auto login failed");
      }
    } catch (err) {
      console.error("❌ Submit Error:", err?.response?.data || err);
      setError(
        err?.response?.data?.sql ||
          err?.response?.data?.message ||
          err?.message ||
          "Something went wrong. Please try again.",
      );
    } finally {
      setSubmitting(false);
    }
  };

  /* ------------------------------------------------
     SUCCESS SCREEN
  ------------------------------------------------ */
  if (submitted && matriId) {
    return (
      // <div className="min-h-screen flex items-center justify-center">
      <div className="flex justify-center mt-10">
        <div className="bg-white shadow-lg rounded-xl p-10 text-center">
          <CheckCircle className="w-16 h-16 text-green-500 mx-auto" />
          <h2 className="text-2xl font-bold mt-4">Registration Complete</h2>
          <p className="text-xl mt-2 font-bold text-rose-700">{matriId}</p>
        </div>
      </div>
    );
  }

  /* ------------------------------------------------
     ERROR SCREEN
  ------------------------------------------------ */
  if (error) {
    return (
      // <div className="min-h-screen flex items-center justify-center">
      <div className="flex justify-center mt-10">
        <div className="bg-white shadow-lg rounded-xl p-10 text-center">
          <AlertCircle className="w-16 h-16 text-red-500 mx-auto" />
          <h2 className="text-2xl font-bold text-red-600 mt-4">
            Submission Failed
          </h2>
          <p className="text-gray-700 mt-4">{error}</p>

          <button
            onClick={() => setError("")}
            className="mt-6 px-6 py-3 bg-rose-600 text-white rounded-lg"
          >
            Try Again
          </button>
        </div>
      </div>
    );
  }

  /* ------------------------------------------------
     DEFAULT SCREEN
  ------------------------------------------------ */

  return (
    <div className="flex justify-center pt-4 pb-10">
      <div className="bg-white shadow-lg rounded-xl p-10 text-center max-w-md w-full">
        <h2 className="text-xl font-semibold mb-4">Submit Registration</h2>

        <button
          onClick={handleSubmit}
          disabled={submitting}
          className="px-8 py-3 bg-gradient-to-r from-pink-600 to-yellow-500 text-white rounded-lg flex items-center gap-2 justify-center mx-auto"
        >
          {submitting ? <Loader2 className="animate-spin" /> : "Submit Form"}
        </button>
      </div>
    </div>
  );
}
